import {QbParticipantCollection} from "./base"
import {HEAD, PUT} from "@qb-assets-js/qb-fetch";

self.slotsMap = new Map();

export class QbSlot extends QbParticipantCollection {
    get payload() {
        return {
            itemid: this.itemid,
            slot_index: this.index
        };
    }

    get init() {
        super.init;
        if(this.parentNode?.nodeName === "QB-PARTICIPANTS") this.initParticipantsNode;
        this.contentRoot.firstElementChild.events = [this, {click: "click_avatar"}]
    }

    handleEvent_click_avatar(evt) {
        if(evt.metaKey) QbChat.focus().insert(`@${this.index}`);
    }

    get initParticipantsNode() {
        self.slotsMap.set(this.index, this);
        self.slotsMap.set(this.itemid, this);
        if(this.querySelector('input[name="slot"]')) return;
        if(self.isMc) {
            cT.CheckBox("slot", this.dataset.index, false, {
                aria: {label: _("Select Team")},
                autocomplete: "off",
                afterbegin: this,
                title: _("Select Team"),
                events: [this, "change"]
            });
            this.addEventListener("dragover", this);
            this.addEventListener("drop", this);
            cT.CheckBox("pause", this.dataset.slot_index, false, {
                class: "play-pause",
                ariaLabel: _("Pause Team"),
                title: _("Pause Team"),
                autocomplete: "off",
                events: [this, {change: "toggle_pause"}]
            });
            DIV({beforeend: this, class: "join-team", title: _("No Join Team Policy")}, "🚫");
        }
        else if(self.isPlayer) {
            this.slot_select;
            if(this.index === 0 || this.dataset.index === "0") return;
            BUTTON({
                ariaLabel: "Team settings",
                beforeend: this,
                class: "edit nobutton",
                events: [this, {click: "edit"}]
            }, "⚙️");
        }
    }

    handleEvent_toggle_pause(evt) {
        this.dispatch('qb-send', {action: "pause", paused: evt.target.checked});
    }


    handleEvent_change(evt) { this.parentNode.handleEvent_change(evt)}

    handleEvent_dragover(evt) { this.parentNode.handleEvent_dragover(evt)}

    handleEvent_drop(evt) { this.parentNode.handleEvent_drop(evt)}

    get isMySlot() { return this.itemid == ME.slot_id }

    set current_index(current_index) {
        const participants = this.parentNode?.matches("qb-participants") ? this.parentNode : null;
        const nodes = participants?.querySelectorAll(`:scope > [data-slot_index="${this.slot_index}"]`);
        let target;
        if(!current_index) return delete this.dataset.current_index;

        if(this.dataset.current_index === current_index) return;
        this.dataset.current_index = current_index;
        if(!participants) return;
        if(current_index.startsWith("-")) {
            delete this.dataset.seconds;
            this.removeClass("paused");
        }
        if(this.isMySlot) this.show.show_round = current_index;

        const target_index = current_index.substring(0, 2) + "/00";
        if(self.isMc || this.isMySlot) {
            const removeMe = n => n.dataset.slots = n.dataset.slots.split(/\s+/).filter(s => !s && s != this.index).join(' ');
            const addMe = n => n.dataset.slots = [...new Set([this.index, ...(n.dataset.slots || "").split(" ")])].sort().join(" ");
            document.body.querySelectorAll(`qb-index [data-slots~="${this.slot}"]`).forEach(removeMe);
            document.body.querySelectorAll(`qb-index [data-index="${this.current_index}"], [data-index="${target_index}"]`).forEach(addMe);
            document.body.querySelectorAll('qb-index [data-slots=""]').forEach(n => delete n.dataset.slots);
        }
        target = this.show.querySelector(`:scope [data-index="${target_index}"] qb-participants`);
        if(participants === target) return;
        if(target) target.append(...nodes);
        else nodes?.forEach(n => n.remove());
    }


    set paused(value) {
        const isPaused = !!value;
        if(this.isMySlot) {
            //     const hasPaused = document.hasClass("paused");
            // if(isPaused !== hasPaused) {
            document.setClass(isPaused, "paused");
            // console.log(this.show.flow);
            // }
        }
        else if(self.isMc) {
            const pauseCheckbox = this.querySelector('input[name="pause"]');
            if(pauseCheckbox && pauseCheckbox.checked !== isPaused) pauseCheckbox.checked = isPaused;
        }
    }

    set seconds(value) {
        this.dataset.seconds = value;
    }

    set timer(value) {
        if(!this.isMySlot) return;
        const timer = document.getElementById("timer");
        timer.end = value;
    }


    get current_index() { return this.dataset.current_index }

    set member_only(value) { this.setClass(value, "member-only") }

    get member_only() { this.hasClass("member-only") }


    update(value) {
        const {current_index, ...other} = value;
        super.update(other);
        if('current_index' in value) this.current_index = current_index;
        return this;
    }

    // get defaults() {
    //     return {
    //         avatar: '',
    //         name: this.index ? '"Team\\00a0" var(--slot-index)' : "In no Team"
    //     };
    // }
    //
    // get selector() {
    //     return `[itemid="${this.itemid}"]`;
    // }
    //
    // get finalize() {
    //     if('slotIndex' in self) this.joinNode = this.index === self.slotIndex;
    // }


    //     const node = this.querySelector(".slot-join-token") || SPAN({
    //         class: "slot-join-token",
    //         beforeend: this,
    //         events: [this, "click"]
    //     });
    //     node.textContent = value;
    // }
    //
    // set team_join_token(value) {
    //     const node = this.querySelector(".team-join-token") || SPAN({
    //         class: "team-join-token",
    //         beforeend: this,
    //         events: [this, "click"]
    //     });
    //     node.textContent = value;
    // }
    //
    // set joinNode(checked) {
    //     const node = this.querySelector("label.join") || LABEL({
    //         beforeend: this,
    //         class: "join"
    //     }, INPUT({type: "radio", value: this.index, name: "join-slot", events: [this, {change: "apply"}]}),
    //         SPAN(_("Join"))
    //     );
    //     node.firstElementChild.checked = checked;
    // }
    //
    // handleEvent_apply(evt) {
    //     HEAD(location.toString().replace(/\d+$/, `${evt.target.value}`)).result({
    //         "202": (d) => { console.log(202, d) },
    //         "406": (d) => {
    //            this.parentElement.querySelector(`[name="join-slot"][value="${self.slotIndex}"]`).checked = true;
    //            warn(_("You need a team code to join. Please ask one of the team members to give it to you."))
    //         },
    //         "102": (d) => { console.log(102, d) }
    //     });
    // }
    //
    // handleEvent(evt) {
    //     if(/-join-token$/.test(evt.currentTarget.className))
    //             return navigator.clipboard.writeText(`${location.origin}/${evt.currentTarget.textContent}`);
    //     super.handleEvent(evt);
    // }
    //

    set paused_at(_) {}

    set offline(_) {}


}

QbSlot.register;